/**
 * Taurus Version Configuration
 *
 * This file defines the current Taurus version for download tracking.
 * Update this when releasing a new version of Taurus.
 */

export const TAURUS_VERSION = "1.0.0";
